/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import './PkgCard.scss';

const PkgCard = ({ pkgDetails, removeItem }) => {
  const removePkg = () => {
    if (confirm('Are you sure you want to remove this package ?')) {
      const { item_id, item_type } = pkgDetails;
      removeItem(item_id, item_type);
    }
  };

  return (
    <div className="mainContainerX" key={pkgDetails.item_id}>
      <div className="imgContainerXPkg">
        <img src={require('../../images/labpkg.svg')} alt="x" />
      </div>
      <div className="textContainer">
        <div className="textTitle">{pkgDetails.item_name}</div>
        <div className="textTitleGreen">{pkgDetails.sub_text}</div>
        <div className="textSubtitlepkg">
          <img src={require('../../images/time.svg')} alt="x" />{pkgDetails.tat_text}
        </div>
      </div>
      <div className="priceContainer">
        <div className="mrPrice">&#8377;{pkgDetails.mrp}</div>
        <div className="pePrice">&#8377;{pkgDetails.pe_selling_price}</div>
      </div>
      <div className="deleteContainer" onClick={removePkg}>
        <img src={require('../../images/remove.svg')} alt="x" />
      </div>
    </div>
  );
};

PkgCard.propTypes = {
  pkgDetails: PropTypes.object.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default PkgCard;
